// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-title[data-v-1332a0aa]{display:flex;flex-direction:row;justify-content:space-between;margin:24px 0}.page-title .title[data-v-1332a0aa]{display:flex;font-weight:800;font-size:28px;margin:0;align-items:center;gap:12px;letter-spacing:-.8px;color:var(--pult-text)}.page-title .button-place[data-v-1332a0aa]{display:flex}", ""]);
// Exports
module.exports = exports;
